.ee{padding:0.5rem;}